import { useEffect } from 'react'
import { App } from '@capacitor/app'
import { isNativePlatform } from '../../lib/platform'
import { nativePathFromDeepLink } from './acquisition-intent'

export function NativeDeepLinkHandler() {
  useEffect(() => {
    if (!isNativePlatform()) return
    let active = true
    const registration = App.addListener('appUrlOpen', ({ url }) => {
      if (active) {
        window.history.pushState(null, '', nativePathFromDeepLink(url))
        window.dispatchEvent(new PopStateEvent('popstate'))
      }
    })
    return () => { active=false; void registration.then(handle=>handle.remove()) }
  }, [])
  return null
}
